/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import { useContext } from 'react';
import { SFXContext } from '@/context/sfx-context/sfx-context.tsx';

export const useGlobalSFX = () => useContext(SFXContext);